// Generic browser-side CSV helpers, shared across modules.
//
// Extracted from access-grants/lib/grants-to-csv.ts, which the tenant Trusted
// Principals export had copied verbatim. Both consumers now import from here:
// the access-grants grant export (relative) and the tenant trusted-principals
// export (via the `accessGrants/shared/csv` alias). Keep this file free of
// module-specific types so it stays a plain utility.

// Excel / Calc / Numbers treat any cell starting with one of these chars as a
// formula. Principal labels, comments, reasons, etc. can plausibly start with
// `-` or `@`, and a malicious resource policy can plant `=cmd|'...'` style
// payloads. Prefix with a single quote so the cell stays text.
const FORMULA_TRIGGERS = new Set(['=', '+', '-', '@', '\t', '\r']);

export function escapeCell(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  let str = String(value);
  if (str.length > 0 && FORMULA_TRIGGERS.has(str[0])) {
    str = `'${str}`;
  }
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function downloadCsv(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
